import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";
import { planTiers } from "@/react/helpers/planHelpers";

import { usePlans } from "../../RegularPlan/PlansContext";
import { SubmitButton } from "../../RegularPlan/SubmitButton";
import { BillingIntervalRadio } from "./BillingIntervalSelector/BillingIntervalRadio";
import { PlanPrice } from "./PlanInfo/PlanPrice";
import { PlanSavings } from "./PlanInfo/PlanSavings";
import { PlanTitle } from "./PlanInfo/PlanTitle";
import { PlanSummaryContainer } from "./PlanSummaryContainer";
import { PlanSummarySkeleton } from "./PlanSummarySkeleton";
import { PlusCustomOfferSummary } from "./PlusCustomOfferSummary";
import { PlusPlanSummary } from "./PlusPlanSummary";

export const PlanSummary = () => {
  const { selectedPlan, selectedPlanTier, customPlanOffer } = usePlans();

  if (selectedPlanTier === planTiers.plus) {
    if (customPlanOffer) {
      return <PlusCustomOfferSummary />;
    }

    return (
      <PlusPlanSummary
        title={
          <Typography.LabelXl weight="bold" color="text-dark">
            {t("pricing_plans.plan_settings.plus_plan_summary.title")}
          </Typography.LabelXl>
        }
        description={t(
          "pricing_plans.plan_settings.plus_plan_summary.description",
        )}
        source="plans_page"
      />
    );
  }

  if (!selectedPlan) {
    return <PlanSummarySkeleton />;
  }

  return (
    <PlanSummaryContainer>
      <Typography.LabelXl weight="semibold">
        {t("pricing_plans.plan_settings.plan_summary.title")}
      </Typography.LabelXl>
      <BillingIntervalRadio />
      <div>
        <PlanTitle />
        <PlanPrice />
      </div>
      <PlanSavings />
      <SubmitButton plan={selectedPlan} />
    </PlanSummaryContainer>
  );
};
